import { useState, useEffect } from 'react';
import { FeatureConfigService } from '../services/featureConfigService';

export const useFeatureFlags = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [, forceUpdate] = useState({});

    const service = FeatureConfigService.getInstance();

    useEffect(() => {
        // Subscribe to feature flag updates
        const unsubscribe = service.subscribe(() => {
            setIsLoaded(service.isLoaded);
            forceUpdate({}); // Force re-render when features change
        });

        // Load features if not already loaded
        if (!service.isLoaded) {
            service.loadFeatures().then(() => {
                setIsLoaded(service.isLoaded);
            });
        } else {
            setIsLoaded(true);
        }

        return unsubscribe;
    }, [service]);

    return {
        isLoaded,
        canAccess: (featureKey: string) => service.canAccess(featureKey),
        getConfiguration: <T = any>(configKey: string) =>
            service.getConfiguration<T>(configKey),
        isDoubleSignatureRequired: (
            transactionType: 'withdrawal' | 'deposit' | 'inventory' | 'disposal'
        ) => service.isDoubleSignatureRequired(transactionType),
        refreshFeatures: () => service.refreshFeatures(),
        setFeature: (key: string, enabled: boolean) =>
            service.setFeature(key, enabled),
        getAllFeatures: () => service.getAllFeatures(),
        getAllConfigurations: () => service.getAllConfigurations(),
    };
};

export const useFeatureFlag = (featureKey: string) => {
    const { isLoaded, canAccess } = useFeatureFlags();

    return {
        isLoaded,
        isEnabled: canAccess(featureKey),
    };
};
